import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { useTranscriptionSync } from '@app/modules/audit/hooks/useTranscriptionSync';
import { toTimestamp } from '@mi-front/core';
import React, { memo, useEffect, useState } from 'react';
import { FormattedTranscriptionType } from './transcriptions.types';
import TranscriptionSyncWrapper from './TranscriptionSyncWrapper';

export interface TranscriptionTranscriptCellProps {
  original: FormattedTranscriptionType;
  index: number;
  renderedCellValue: React.ReactNode;
}

/**
 * Cell content for the transcript column: syncs with playback and shows word-level menu on hover for speech rows.
 */
const TranscriptionTranscriptCell = memo(
  ({ original, index, renderedCellValue }: TranscriptionTranscriptCellProps) => {
    const [isCurrRow, setIsCurrRow] = useState(false);
    const currentTs = usePlaybackCurrentTs();
    const { timeRef } = useTranscriptionSync();

    useEffect(() => {
      const curr =
        toTimestamp(original.time) <= currentTs! && toTimestamp(original.time) + 30000 > currentTs!;
      setIsCurrRow(curr);
      if (curr) {
        timeRef.current = toTimestamp(original.time);
      }
    }, [original.time, currentTs]);

    return (
      <div>
        {original.tags === 'speech' ? (
          <TranscriptionSyncWrapper
            words={original.original_words}
            isCurrentRow={isCurrRow}
            timestamp={original.time}
          />
        ) : (
          <div key={`text-transcript-${index}`}>{renderedCellValue}</div>
        )}
      </div>
    );
  },
);

TranscriptionTranscriptCell.displayName = 'TranscriptionTranscriptCell';

export default TranscriptionTranscriptCell;
